import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Button from '@Components/Button';


export default function AlertToggleButton (props) {
  const {
    open,
    toggle,
    showLabel,
    hideLabel,
  } = props;

  return (
    <Button
      onClick={toggle}
      buttonConfig={{
        className: classnames('alert-description--toggle-button'),
        type: 'link',
        label: open ? hideLabel: showLabel,
        color: 'blue',
        size: 'sm',
        e2eName: 'toggle-alert-description',
      }}
      iconConfig={{
        name: open ? 'chevron-up' : 'chevron-down',
        position: 'after',
      }}
    />
  );
}

AlertToggleButton.propTypes = {
  open: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  showLabel: PropTypes.string.isRequired,
  hideLabel: PropTypes.string.isRequired,
};
